import * as action from './roomAction'
import { default as actionType } from './roomActionType'
import { default as reducer } from './roomReducer'

export const ROOM = {
  action,
  actionType,
  reducer
}
